export default __webpack_public_path__ + "static/media/1424.7495fce9.png";